/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Why it is suggested: 'sameSearchElsewhere' = the same criteria beyond the map area (nearest first); 'nearby' = another activity in the map area; 'popular' = among the most booked anywhere.
 */
export enum ActivitySearchResultsAllOfSuggestionsItemAllOfSuggestionReason {
  sameSearchElsewhere = 'sameSearchElsewhere',
  nearby = 'nearby',
  popular = 'popular'
}
